// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wDSG","buttons":"styles_buttons__1Q5Vw"};